import { render, staticRenderFns } from "./ChannelsModal.vue?vue&type=template&id=24393788&scoped=true"
import script from "./ChannelsModal.vue?vue&type=script&lang=js"
export * from "./ChannelsModal.vue?vue&type=script&lang=js"
import style0 from "./ChannelsModal.vue?vue&type=style&index=0&id=24393788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24393788",
  null
  
)

export default component.exports